const translate = {
    'pt-BR': {
        nome: 'O campo "Nome" não foi preenchido corretamente',
        sobrenome: 'O campo "Sobrenome" não foi preenchido corretamente',
        email: {
            required: 'O campo "Email" não foi preenchido',
            email: 'Digite um "Email" válido',
        },
        'tel-celular': {
            required: 'O campo "Telefone" não foi preenchido',
            minlength: 'Digite um "Telefone" válido',
        },
        assunto: 'O campo "Assunto" não foi definido',
        mensagem: 'O campo "Mensagem" não foi preenchido',
        age: 'Você precisa confirmar que tem 18 anos ou mais', //TODO: texto
        data: 'Você precisa confirmar se esta de acordo com a coleta de dados', //TODO: texto

        cpf: {
            reclamacaoRequired: 'O campo "CPF" não foi preenchido',
            cpf: 'O campo "CPF" apresenta um número inválido',
        },
        cep: {
            reclamacaoRequired: 'O campo "CEP" não foi preenchido',
            cep: 'O campo "CEP" não foi preenchido',
        },
        endereco: 'O campo "Endereço" não foi preenchido',
        numero: 'O campo "Número" não foi preenchido',
        bairro: 'O campo "Bairro" não foi preenchido',
        estado: 'O campo "Estado" não foi preenchido',
        cidade: 'O campo "Cidade" não foi preenchido',
        pais: 'O campo "País" não foi preenchido',
        produto: 'O campo "Produto" não foi preenchido',
        lote: 'O campo "Lote" não foi preenchido',
        validade: {
            reclamacaoRequired: 'O campo "Data de Validade" não foi preenchido',
            validDate: 'O campo "Data de Validade" foi preenchido com uma data inválida.',
        },
    },
};

const html = document.querySelector('html');
const language = html.getAttribute('lang');

const state = $('.contact-form select[name="estado"]');
state.on('change', ()=> { 
    const returnState = state.val();

    $.ajax({
        type: "GET",
        url: `https://brasilapi.com.br/api/ibge/municipios/v1/${returnState}`,
        contentType: "application/json; charset=utf-8",
        async: false,
    }).done(function (response) {
        cidades = "";
        
        $.each(response, function (c, cidade) {
            const nomeCidade = cidade.nome;        
            cidades +=
                '<option value="' +
                nomeCidade +
                '">' +
                nomeCidade +
                "</option>";
        });

        $("#cidade").html(cidades);
    });

})

function setupContact() {
    const form = $('.contact-form');
    const btnSubmit = form.find('.btn-submit');
    const containerErrors = form.find('.errors');
    const containerSuccess = form.find('.success');

    form.find("input[name='tel-celular']").mask('(00) 00000-0000');
    form.find("input[name='cpf']").mask('000.000.000-00');
    form.find("input[name='cep']").mask('00000-000');
    form.find("input[name='validade']").mask('00/00/0000');

    form.find('select[name="assunto"]').on('change', function () {
        const v = $(this).val();
        $('.contact-subject').addClass('hidden');
        $('.contact-subject-' + v).removeClass('hidden');
    });

    form.find('#attach').on('change', function () {
        const filename = $.map(this.files, function (file) {
            return file.name;
        });

        $(this).parent().find('.filename').html(filename.join(','));
    });

    //custom validation rule
    $.validator.addMethod(
        'customemail',
        function (value, element) {
            return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value);
        },
        'Digite um e-mail válido'
    );

    $.validator.addMethod(
        'customname',
        function (value, element) {
            return !/[0-9!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/,!?-]/g.test(value);
        },
        'Digite um nome válido'
    );

    $.validator.addMethod(
        'customtel',
        function (value, element) {
            if (value.length > 14) {
                return true;
            }
        },
        'Digite um telefone válido'
    );

    form.validate({
        onFocusOut: true,
        focusInvalid: false,
        errorClass: 'input-error',
        errorElement: 'span',
        errorLabelContainer: '.contact-form .errors',
        rules: {
            assunto: { number: true, required: true },
            nome: {
                required: {
                    depends: function () {
                        $(this).val();
                        return true;
                    },
                },
                customname: true,
            },
            sobrenome: {
                required: {
                    depends: function () {
                        $(this).val();
                        return true;
                    },
                },
                customname: true,
            },
            email: {
                required: {
                    depends: function () {
                        $(this).val($(this).val().trim());
                        return true;
                    },
                },
                customemail: true,
            },
            'tel-celular': {
                required: {
                    depends: function () {
                        $(this).val();
                        return false;
                    },
                },
                customtel: true,
            },
            mensagem: 'required',
            age: 'required',
            data: 'required',
            cpf: {
                reclamacaoRequired: true,
                cpf: true,
            },
            cep: {
                reclamacaoRequired: true,
                cep: true,
            },
            endereco: 'reclamacaoRequired',
            numero: 'reclamacaoRequired',
            // 'complemento': 'reclamacaoRequired',
            bairro: 'reclamacaoRequired',
            estado: {
                required: true,
            },
            cidade: {
                required: true,
            },
            pais: 'reclamacaoRequired',
            produto: 'reclamacaoRequired',
            lote: 'reclamacaoRequired',
            // 'date_fab': 'reclamacaoRequired',
            validade: {
                reclamacaoRequired: true,
                validDate: true,
            },
        },
        messages: translate[language],
        invalidHandler: function () {
            btnSubmit.removeClass('loading');
            $('.contact-form .success').empty();
            document.querySelector('.modal-erro-form').classList.add('active');
            document.querySelector('.modal-erro-form .closeModalForm').addEventListener('click', () => {
                document.querySelector('.modal-erro-form').classList.remove('active');
            });
            const anchorForm = document.querySelector('.component-contact-form');
            anchorForm.scrollIntoView();
        },
        submitHandler: function (form, event) {
            if (btnSubmit.hasClass('loading')) {
                return;
            }

            btnSubmit.addClass('loading');
            btnSubmit.prop('disabled', true);

            event.preventDefault();
            event.stopPropagation();

            reloadCaptcha('contact', 'g-recaptcha-response', function () {
                $.ajax({
                    type: 'POST',
                    url: $(form).data('action'),
                    data: new FormData(form),
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        btnSubmit.removeClass('loading');
                        //TODO: melhorar mensagem de sucesso? Ver com DA
                        form.reset();
                        // containerSuccess.html(data);
                        document.querySelector('.modal-sucesso-form').classList.add('active');
                        document.querySelector('.modal-sucesso-form .closeModalForm').addEventListener('click', () => {
                            document.querySelector('.modal-form').classList.remove('active');
                        });
                        $('.contact-form .filename').html('ESCOLHA UMA IMAGEM');

                        btnSubmit.prop('disabled', false);
                    },
                    error: function (data) {
                        btnSubmit.removeClass('loading');
                        // containerSuccess.empty();
                        document.querySelector('.modal-erro-form').classList.add('active');
                        document.querySelector('.modal-erro-form .closeModalForm').addEventListener('click', () => {
                            document.querySelector('.modal-erro-form').classList.remove('active');
                        });

                        btnSubmit.prop('disabled', false);

                        if (data.responseJSON || data.responseText) {
                            containerErrors
                                .html(
                                    data.responseJSON && data.responseJSON.errors
                                        ? Object.values(data.responseJSON.errors).map((v) => v[0] + '<br>')
                                        : data.responseJSON.message || data.responseText
                                )
                                .show({ duration: 0 });
                        }

                        try {
                            reloadCaptcha('contact');
                            document.querySelector('.modal-sucesso-form').classList.remove('active');
                        } catch (e) {
                            console.log(e);
                        }
                    },
                });
            });
        },
    });
}

function testContact() {
    const form = $('.contact-form');
    form.find("select[name='assunto']").val('0070');
    form.find("input[name='nome']").val('Rafael');
    form.find("input[name='sobrenome']").val('Busetti');
    form.find("input[name='email']").val('rafael@base.digital');
    form.find("input[name='tel-celular']").val('(54) 99000-0000');
    form.find("textarea[name='mensagem']").val(
        'Estou testando o formulário que será integrado no novo site de Piracanjuba ProForce.'
    );
    form.find("input[name='age']").attr('checked', 'checked');
    form.find("input[name='data']").attr('checked', 'checked');
    form.find("input[name='option']").attr('checked', 'checked');
    form.find("input[name='cpf']").val('054.799.870-89');
    form.find("input[name='cep']").val('95084-000');
    form.find("input[name='endereco']").val('Endereço');
    form.find("input[name='numero']").val('Número');
    form.find("input[name='complemento']").val('APTO XXXX');
    form.find("input[name='bairro']").val('Bairro');
    form.find("select[name='estado']").val('RS');
    // A cidade será carregada automaticamente quando o estado for selecionado
    form.find("select[name='pais']").val('BR');
    form.find("input[name='produto']").val('Nome do produto');
    form.find("input[name='lote']").val('1233123121321');
    form.find("input[name='validade']").val('25/04/2022');
}

function initialize() {
    setupContact();
    // testContact(); //Apenas para teste
}

initialize();
